import {buildColumn, XLARGE_CELL_WIDTH} from '@eitje/web_components'
import {ArrayCell} from '~/components/advanced_table/components/cells/array_cell'

export const columns = [
	{
		accessorKey: 'full_name',
		header: 'name',
		width: XLARGE_CELL_WIDTH,
	},
	{
		accessorKey: 'email',
		width: XLARGE_CELL_WIDTH,
	},
	{
		id: 'environments',
		width: XLARGE_CELL_WIDTH,
		accessorFn: user => user.environments._map('naam'),
		cell: ArrayCell,
	},
	{
		id: 'organisations',
		width: XLARGE_CELL_WIDTH,
		accessorFn: user => user.organisations._map('name'),
		cell: ArrayCell,
	},
	{
		accessorKey: 'id',
	},
].map(buildColumn)
